// useAgen — state token agen (mirip useSession, lapisan penyimpanan lokal).
const TOKEN_KEY = 'ca_agent_token'

// Seluruh akses localStorage dibungkus try/catch. Di mode privat sebagian
// peramban MELEMPAR pada setItem, bukan sekadar mengabaikannya, sehingga satu
// panggilan telanjang cukup untuk mematikan pendaftaran agen dan pembelian
// grosir dengan galat yang tidak menyebut penyebabnya sama sekali.
export function simpanTokenAgen(token: string) {
  if (!import.meta.client) return
  try {
    localStorage.setItem(TOKEN_KEY, token)
  } catch {
    // Token hilang saat halaman ditutup; dashboard tetap bisa dipakai
    // selama sesi ini.
  }
}

export function ambilTokenAgen(): string | null {
  if (!import.meta.client) return null
  try {
    return localStorage.getItem(TOKEN_KEY)
  } catch {
    return null
  }
}

export function hapusTokenAgen() {
  if (!import.meta.client) return
  try {
    localStorage.removeItem(TOKEN_KEY)
  } catch {
    // Tidak ada yang bisa dilakukan, dan tidak ada yang perlu dilakukan.
  }
}

export function headerAgen(): Record<string, string> {
  const t = ambilTokenAgen()
  return t ? { 'X-Agent-Token': t } : {}
}

// ── Penangkap kode referral ──────────────────────────────────────────────
//
// Tautan referral yang disebar agen berbentuk https://tools.coreasia.id/?ref=AGEN-XXXX
// dan mendarat di BERANDA, bukan di halaman checkout. Sebelum ini `ref` hanya
// dibaca dari query halaman checkout, sehingga diskon dan komisi tidak pernah
// terjadi kecuali seseorang mengetik sendiri /checkout?sku=...&ref=...
//
// Karena itu kodenya ditangkap sekali di middleware global lalu disimpan, dan
// checkout membacanya dari sini.

const REF_KEY = 'ca_agent_ref'
/** Masa simpan kode referral. Cukup panjang untuk orang yang menunda membeli,
 *  cukup pendek untuk tidak membuntuti seseorang berbulan-bulan. */
const REF_UMUR_MS = 30 * 24 * 60 * 60 * 1000

export function simpanRef(ref: string) {
  if (!import.meta.client) return
  const bersih = ref.trim()
  if (!bersih) return
  try {
    localStorage.setItem(REF_KEY, JSON.stringify({ ref: bersih, ts: Date.now() }))
  } catch {
    // Mode privat atau storage penuh: referral hilang, pembelian tetap jalan.
  }
}

export function ambilRefTersimpan(): string {
  if (!import.meta.client) return ''
  try {
    const mentah = localStorage.getItem(REF_KEY)
    if (!mentah) return ''
    const { ref, ts } = JSON.parse(mentah) as { ref?: string; ts?: number }
    if (!ref || !ts || Date.now() - ts > REF_UMUR_MS) {
      localStorage.removeItem(REF_KEY)
      return ''
    }
    return ref
  } catch {
    return ''
  }
}
